import { saveThemeEpic } from './save-theme';
import { combineEpics } from 'redux-observable';
import { handleErrorsEpic } from './handle-errors';
import { startLoadingEpic, endLoadingEpic } from './handle-loading';
import { destroyDialogEpic } from './destroy-dialog';
import { openDialogEpic } from './open-dialog';
import { handleResizeEpic } from './handle-resize';
import { scrollTopEpic } from './scroll-top';
import { closeMenusEpic } from './close-menus';
import { resetAfterLogoutEpic } from './reset-after-logout';
import { ShowToastNotificationEpic } from './show-toast-notifications';
import { HideToastNotificationEpic } from './hide-toast-notifications';
import { handlePageScrollEpic } from './restore-scroll-after-close-menu';

const uiEpic = combineEpics(
  handleErrorsEpic,
  startLoadingEpic,
  endLoadingEpic,
  destroyDialogEpic,
  openDialogEpic,
  handleResizeEpic,
  scrollTopEpic,
  closeMenusEpic,
  resetAfterLogoutEpic,
  saveThemeEpic,
  ShowToastNotificationEpic,
  HideToastNotificationEpic,
  handlePageScrollEpic
);

export default uiEpic;
